export default __webpack_public_path__ + "static/Poppins-Thin-59ff6a729e30c99b478e7ac8fd2dd309.ttf";